module.exports = __webpack_public_path__ + "static/media/delete.ee0ca634.svg";